import React, { PureComponent as Component } from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Toolbars as ToolBarContainer } from '../../../../../components/Card/CardHeaderWithToolbars';


export default class Toolbars extends Component {
  render(){
    return(
      <ToolBarContainer>
        <Button 
          type="button"
          title="Refresh"
          color="info"
          size="sm"
          className="with-toolbars__toolbars__btn"
          onClick={this.props.onRefreshList}
        >            
          <i className="fa fa-refresh"></i>
        </Button>
        <Button 
          type="button"
          title="Reset filter"
          color="warning"
          size="sm"
          className="with-toolbars__toolbars__btn"
          onClick={this.props.onResetFilter}
        >            
          <i className="fa fa-ban"></i>
        </Button>
        <Button 
          type="button"
          title="Search and Filter Data"
          size="sm"
          className={classNames('with-toolbars__toolbars__btn',{'btn-danger':this.props.isOpen})}
          onClick={this.props.onToggleFilter}
        >            
          <i className={classNames('fa', {'fa-sliders':!this.props.isOpen,'fa-minus':this.props.isOpen})}></i>
        </Button>
				<Button 
          type="button"
          title="Export sales"
          size="sm"
          className="with-toolbars__toolbars__btn"
          onClick={this.props.onToggleExport}
        >            
          <i className={classNames('fa', {'fa-download':!this.props.exporting,'fa-spinner fa-spin':this.props.exporting})}></i>
        </Button>
        <Button 
          type="button"
					color="success"
          title="Print Multiple Order"
          size="sm"
          className={classNames('with-toolbars__toolbars__btn',{'btn-success':this.props.isOpenPrint})}
          onClick={this.props.onTogglePrint}
        >            
          <i className={classNames('fa', {'fa-print':!this.props.isOpenPrint,'fa-minus':this.props.isOpenPrint})}></i>
        </Button>
      </ToolBarContainer>
    )
  }
}

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  exporting: propTypes.bool,
  onToggleFilter: propTypes.func,
  onToggleExport: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func
}
Toolbars.defaultProps = {
	isOpen: false,
	exporting: false
}